export default __webpack_public_path__ + "static/media/Greet.8f117eb2.svg";